// ----------------------------------------------------------------------

export default function FormControlLabel(theme) {
  return {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          '& .MuiFormControlLabel-label': {
            color: theme.palette.text.secondary,
            fontSize: '0.875rem',
            fontWeight: 400,
            lineHeight: 1.5,
          },
        },
      },
    },
  };
}
